module.exports = __webpack_public_path__ + "static/media/oxford_logo.26d25c57.jpeg";